import { useSignup } from '../hooks/useSignup';

/**
 * サインアップページのContainer Component
 */
export const SignupContainer: React.FC = () => {
  useSignup();
  return null;
};
